import React from 'react';

const SortableHeader = ({ column, label, sortColumn, sortDirection, onSort }) => (
  <button
    type="button"
    className={`variables-panel__col variables-panel__col--sortable${
      sortColumn === column ? ' is-active' : ''
    }`}
    onClick={() => onSort(column)}
    aria-sort={sortColumn === column ? (sortDirection === 'asc' ? 'ascending' : 'descending') : 'none'}
  >
    <span>{label}</span>
    {sortColumn === column && (
      <span className="variables-panel__sort-indicator" aria-hidden>
        {sortDirection === 'asc' ? '↑' : '↓'}
      </span>
    )}
  </button>
);

export default SortableHeader;
